import { createContext, useContext } from "react";

type UnsavedEditsSyncContextType = {
  flushUnsavedEdits: () => Promise<boolean>;
  pauseSync: () => void;
  resumeSync: () => void;
  // Mutable version counter. Increment to tell all trackers to re-baseline on the next form change.
  trackerResetVersionRef: React.RefObject<number>;
  registerRequiredKeys: (subtemplateIndex: number, keys: Set<string>) => void;
  unregisterRequiredKeys: (subtemplateIndex: number) => void;
};

const defaultVersionRef = { current: 0 };

export const UnsavedEditsSyncContext = createContext<UnsavedEditsSyncContextType>({
  flushUnsavedEdits: () => Promise.resolve(true),
  pauseSync: () => undefined,
  resumeSync: () => undefined,
  trackerResetVersionRef: defaultVersionRef,
  registerRequiredKeys: () => undefined,
  unregisterRequiredKeys: () => undefined
});

export const useUnsavedEditsSyncContext = () => useContext(UnsavedEditsSyncContext);
